import React, { useState, useEffect, memo } from "react";
import { useSelector } from "react-redux";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { draggableMoveAnItem, roleCheck } from "utils/index";
import { getBaseUrl, getCurrentUser } from "../../reducers";
import { updateVrDraftsmanOrder } from "../../../../requesters/jobServiceRequester";
import DraggableVrDraftingJobServiceRow from "./DraggableVrDraftingJobServiceRow";

const VrDraftingJobServicesTable = ({
  jobServices, setJobServices, reloadData
}) => {
  const baseUrl = useSelector(getBaseUrl);
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const [jobServicesForVrDraftsman, setJobServicesForVrDraftsman] = useState(jobServices)

  const onDragEnd = result => {
    if (!result.destination) return;
    const destinationIdx = result.destination.index
    if (destinationIdx === result.source.index) return;

    const destinationJob = jobServicesForVrDraftsman[destinationIdx]
    updateVrDraftsmanOrder(baseUrl, result.draggableId, destinationJob.id)
    const rows = draggableMoveAnItem(
      jobServicesForVrDraftsman,
      result.source.index,
      destinationIdx
    );
    setJobServicesForVrDraftsman(rows);
  }

  const MemorizedRows = memo(({ jobServices, setJobServices, reloadData }) => jobServices.map((jobService, index) => (
    <DraggableVrDraftingJobServiceRow
      jobService={jobService}
      setJobServices={setJobServices}
      reloadData={reloadData}
      index={index}
      key={jobService?.id} />
  )));

  const DraggableVrDraftingJobServiceRows = () => (
    <DragDropContext onDragEnd={result => {
      onDragEnd(result)
    }}>
      <Droppable droppableId="list">
        {provided => (
          <tbody ref={provided.innerRef} {...provided.droppableProps}>
            <MemorizedRows
              jobServices={jobServicesForVrDraftsman}
              setJobServices={setJobServicesForVrDraftsman}
              reloadData={reloadData} />
            {provided.placeholder}
          </tbody>
        )}
      </Droppable>
    </DragDropContext>
  )

  useEffect(() => {
    setJobServicesForVrDraftsman(jobServices)
  }, [jobServices])

  return (
    <div className="table-responsive">
      <table className="table table-listing table-hover">
        <thead>
          <tr>
            <th></th>
            <th>Job No.</th>
            <th>Job Address</th>
            <th>Job Service</th>
            <th className="text-left">Surveyor</th>
            <th className="text-center absorbing-column">Date of Field Work</th>
            <th className="text-center absorbing-column">VR Draftsman</th>
            <th className="text-center absorbing-column">Status</th>
            <th className="text-center absorbing-column">Due Date</th>
            <th></th>
          </tr>
        </thead>
        {!!jobServicesForVrDraftsman.length && DraggableVrDraftingJobServiceRows()}
      </table>
    </div>
  )
}

export default VrDraftingJobServicesTable